import {Provider} from "@/components/ui/provider"
import AppContent from "@/AppContent";
import {BrowserRouter} from "react-router-dom";
import "@/i18n";

if (process.env.NODE_ENV === "development") {
    require("./mocks");
}

function App() {
    return (
        <Provider defaultTheme="light" forcedTheme="light">
            <BrowserRouter>
                <AppContent/>
            </BrowserRouter>
        </Provider>
    )
}

export default App;
